module.exports = __webpack_public_path__ + "assets/img/_flamengo3.5cac18d3.png";